import React, { useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../AuthContext";
import "./AdminProductView.css";
import Swal from "sweetalert2";
import { toLocalDateString } from "../dateUtils";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const MySwal = Swal.mixin({
    customClass: {
        container: "my-swal-container",
    },
});




function AdminProductView() {
    const { authFetch } = useContext(AuthContext);
    const navigate = useNavigate();

    const [salesData, setSalesData] = useState([]);

    const [products, setProducts] = useState([]);
    const [totals, setTotals] = useState([]);
    const handleRefresh = () => {
        fetchData();
    };


    const [customDateRange, setCustomDateRange] = useState({
        startDate: toLocalDateString(new Date()),
        endDate: toLocalDateString(new Date()),
    });

    const fetchData = async () => {
        try {
            const start = new Date(customDateRange.startDate);
            const end = new Date(customDateRange.endDate);

            var qs = "start=" + toLocalDateString(start) + "&end=" + toLocalDateString(end);


            const response = await authFetch(`${API_BASE_URL}/api/Report/productview?${qs}`);
            if (!response.ok) {
                throw new Error(`Error fetching : ${response.statusText}`);
            }
            const data = await response.json();
            setSalesData(data.productview || []);
            setProducts(data.product || []);
            setTotals(data.totals || []);

            return data;
        } catch (error) {
            MySwal.fire({
                title: "Error!",
                text: "Failed to load data. Please try again.",
                icon: "error",
                confirmButtonColor: "#45a049",
            });
            return [];
        }
    };

    const handleCsvExport = () => {

        try {

            const { rows, dates } = transformData();

            // Build CSV header: "Product" followed by all dates
            let csvContent = "Product," + dates.join(',') + ",Total Unique\n";

            const escapeCSV = (value) => {
                if (value === null || value === undefined) return '';
                const str = String(value);
                if (str.includes(',') || str.includes('"') || str.includes('\n')) {
                    return `"${str.replace(/"/g, '""')}"`;
                }
                return str;
            };

            // Build each row: product name followed by counts for each date
            rows.forEach((row) => {
                const rowData = [
                    escapeCSV(row.productName),
                    ...dates.map(date => {
                        const value = row[`date_${date}`];
                        return value === '' ? '0' : escapeCSV(value);
                    }),
                    escapeCSV(row.uniqueCustomers)
                ];

                csvContent += rowData.join(',') + "\n";
            });

            const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8" });

            const url = URL.createObjectURL(blob);

            const link = document.createElement("a");
            link.href = url;
            link.download = `Ardency_UniqueCustomerView_Report_${toLocalDateString(new Date())}.csv`;

            document.body.appendChild(link);

            // Trigger the download
            link.click();

            // Clean up
            setTimeout(() => {
                document.body.removeChild(link);
                URL.revokeObjectURL(url);
            }, 100);
        } catch (error) {
            MySwal.fire({
                title: "Error!",
                text: "Failed to export CSV. Please try again.",
                icon: "error",
                confirmButtonColor: "#45a049",
            });
        }
    };


    const formatDate = (date) => {
        // Convert Date object to DD/MM/YYYY format
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
    };

    const generateDateRange = (startDate, endDate) => {
        const dates = [];
        const currentDate = new Date(startDate);
        currentDate.setHours(0, 0, 0, 0);

        const end = new Date(endDate);
        end.setHours(0, 0, 0, 0);

        while (currentDate <= end) {
            dates.push(formatDate(new Date(currentDate)));
            currentDate.setDate(currentDate.getDate() + 1);
        }

        return dates;
    };


    const transformData = () => {
        // Generate all dates in the range
        const allDates = generateDateRange(customDateRange.startDate, customDateRange.endDate);

        // Unique customers for the whole range, keyed by product
        const totalMap = {};
        totals.forEach(t => { totalMap[t.productID] = t.uniqueCustomers; });

        // Create a map for quick lookup
        const dataMap = {};
        salesData.forEach(item => {
            const key = `${item.productID}-${item.date}`;
            dataMap[key] = item.count;
        });

        // Build table rows (one row per product)
        const rows = products.map(product => {
            const row = {
                productID: product.productID,
                productName: product.name
            };
            allDates.forEach(date => {
                const key = `${product.productID}-${date}`;
                row[`date_${date}`] = dataMap[key] !== undefined ? dataMap[key] : 0;
            });
            // Deduplicated across the whole range, so deliberately not the sum of the
            // daily columns - one visitor returning on three days counts once here.
            row.uniqueCustomers = totalMap[product.productID] || 0;
            return row;
        });

        return { rows, dates: allDates };
    };

    const { rows, dates } = transformData();


    // if (loading) {
    //     return (
    //         <div className="admin-sales-dashboard-container">
    //             <div className="admin-sales-dashboard-loading">
    //                 <Loading />
    //             </div>
    //         </div>
    //     );
    // }

    const styles = {
        container: {
            padding: '32px',
            backgroundColor: '#f9fafb',
            minHeight: '100vh'
        },
        wrapper: {
            maxWidth: '1200px',
            margin: '0 auto'
        },
        card: {
            backgroundColor: 'white',
            borderRadius: '8px',
            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
            overflow: 'hidden'
        },
        scrollContainer: {
            overflowX: 'auto',
            width: '100%',
            maxWidth: '100%'
        },
        table: {
            width: '100%',
            borderCollapse: 'collapse'
        },
        headerCell: {
            border: '1px solid #d1d5db',
            padding: '12px 24px',
            textAlign: 'center',
            fontWeight: '600',
            color: '#374151',
            backgroundColor: '#f3f4f6',
            whiteSpace: 'nowrap',
            minWidth: '150px'
        },
        stickyHeaderCell: {
            border: '1px solid #d1d5db',
            padding: '12px 24px',
            textAlign: 'left',
            fontWeight: '600',
            color: '#374151',
            backgroundColor: '#f3f4f6',
            position: 'sticky',
            left: 0,
            zIndex: 20,
            minWidth: '250px',
            textTransform: 'uppercase',
            letterSpacing: '0.05em'
        },
        stickyBodyCell: {
            border: '1px solid #d1d5db',
            padding: '16px 24px',
            fontWeight: '500',
            color: '#1f2937',
            position: 'sticky',
            left: 0,
            backgroundColor: 'white',
            zIndex: 10,
            minWidth: '250px'
        },
        bodyCell: {
            border: '1px solid #d1d5db',
            padding: '16px 24px',
            textAlign: 'center',
            color: '#374151',
            minWidth: '150px'
        },
        row: {
            transition: 'background-color 0.2s'
        }
    };

    return (
        <div className="admin-sales-dashboard-container">
            {/* Header Section */}
            <div className="admin-sales-dashboard-header">
                <button
                    className="admin-sales-dashboard-back-btn"
                    onClick={() => navigate("/admin/dashboard")}
                >
                    <i className="fas fa-arrow-left"></i> Back to Dashboard
                </button>
            </div>

            <div className="admin-sales-dashboard-title">
                <h1>Product View Analytics</h1>
                <p>Each product is counted once per customer IP per day. Repeated refreshes are excluded.</p>
            </div>

            <div className="admin-sales-dashboard-refresh" style={{
                marginBottom: '20px',
                display: 'flex',
                justifyContent: 'flex-end',
                gap: '10px'  
            }}>
                <button
                    className="admin-voucher-dashboard-print-btn"
                    onClick={handleCsvExport}
                >
                    <i className="fas fa-file-export"></i> Export Excel
                </button>
                <button
                    className="admin-sales-dashboard-refresh-btn"
                    onClick={handleRefresh}
                >
                    <i className="fas fa-sync-alt"></i> Search
                </button>
            </div>

            <div className="admin-sales-dashboard-row">
                <div className="admin-sales-dashboard-overview">
                    <div className="admin-sales-dashboard-print-section">

                        <div className="admin-sales-dashboard-controls">
                            <div className="admin-sales-dashboard-custom-date">
                                <div className="admin-sales-dashboard-control-group">
                                    <label>Start Date</label>
                                    <input
                                        type="date"
                                        value={customDateRange.startDate || ""}
                                        onChange={(e) =>
                                            setCustomDateRange({
                                                ...customDateRange,
                                                startDate: e.target.value,
                                            })
                                        }
                                    />
                                </div>
                                <div className="admin-sales-dashboard-control-group">
                                    <label>End Date</label>
                                    <input
                                        type="date"
                                        value={customDateRange.endDate || ""}
                                        onChange={(e) =>
                                            setCustomDateRange({
                                                ...customDateRange,
                                                endDate: e.target.value,
                                            })
                                        }
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="admin-sales-dashboard-row">
                <div className="admin-sales-dashboard-trends-container"  >
                    <div className="admin-sales-dashboard-print-section">
                        <div style={styles.scrollContainer}>
                            {products.length > 0 ? (
                                <table style={styles.table}>
                                    <thead>
                                        <tr>
                                            <th style={styles.stickyHeaderCell}>Product</th>
                                            {dates.map(date => (
                                                <th key={date} style={styles.headerCell}>
                                                    {date}
                                                </th>
                                            ))}
                                            <th style={styles.headerCell}>Total Unique</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {rows.map((row, index) => (
                                            <tr
                                                key={row.productID}
                                                style={styles.row}
                                                onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f9fafb'}
                                                onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'white'}
                                            >
                                                <td style={styles.stickyBodyCell}>
                                                    {row.productName}
                                                </td>
                                                {dates.map(date => (
                                                    <td key={date} style={styles.bodyCell}>
                                                        {row[`date_${date}`]}
                                                    </td>
                                                ))}
                                                <td style={{ ...styles.bodyCell, fontWeight: 600 }}>
                                                    {row.uniqueCustomers}
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            ) : (
                                <div className="admin-sales-empty">
                                    <i className="fas fa-eye"></i>
                                    <p className="primary-message">
                                        No products are available for this report.
                                    </p>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default AdminProductView;
